import { Stack, TextField } from "@material-ui/core";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import type { DateRangeFilter } from "utils/listings/table";

type CallFilterDateProps = {
  value: DateRangeFilter;
  onChange: Dispatch<SetStateAction<DateRangeFilter>>;
};

export function CallFilterDate({ value, onChange }: CallFilterDateProps): JSX.Element {
  const { t: translate } = useTranslation();

  const handleChange =
    (type: "min" | "max") =>
    ({ target }: React.ChangeEvent<HTMLInputElement>): void => {
      onChange({ ...value, [type]: target.value });
    };

  const { min, max } = value;

  const bothDateRangeFilled = min && max;

  const invalidStartDateFilter = bothDateRangeFilled && min >= max;
  const invalidEndDateFilter = bothDateRangeFilled && max <= min;

  return (
    <Stack width="100%" direction={{ xs: "column", sm: "row" }} gap={1.5}>
      <TextField
        fullWidth
        label={translate("callsPage.startDate")}
        type="date"
        value={min}
        error={invalidStartDateFilter}
        onChange={handleChange("min")}
        InputLabelProps={{ shrink: true }}
        helperText={
          invalidStartDateFilter ? translate("callsPage.invalidStartDateFilter") : undefined
        }
      />
      <TextField
        fullWidth
        label={translate("callsPage.endDate")}
        type="date"
        value={max}
        error={invalidEndDateFilter}
        onChange={handleChange("max")}
        InputLabelProps={{ shrink: true }}
        helperText={invalidEndDateFilter ? translate("callsPage.invalidEndDateFilter") : undefined}
      />
    </Stack>
  );
}
